import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../../../root/RootReducer";
import {filterUserList} from "../../PresentersActions";
import styles from "./PresentersIndex.module.css";
import PresentersFilters from "./PresentersFilters";
import {motion, AnimatePresence} from "framer-motion";
import {resetUserfilter} from "../../UserFilterActions";
import {changeMenu} from "../../../../root/components/layout/header/HeaderActions";
import PresentersProfiles from "./PresentersProfiles";
import {CircularProgress} from "@material-ui/core";
import {GetRecommendProfessionalList} from "../../../../common/homePage/HomePageActions";

interface checkObject {
  [key: string]: boolean;
}

function PresentersIndex() {
    const dispatch = useDispatch();

    const [checkedSkills, setCheckedSkills] = React.useState<checkObject>({});
    const [checkedTags, setCheckedTags] = React.useState<checkObject>({});

    const {users, isLoading} = useSelector((state: AppState) => {
    // {
    //     users: state.presenters.index.filteredUsers,
    //     isLoading: state.presenters.index.isLoading,
    // }
        return {
            users: state.presenters.index.filteredUsers,
            isLoading: state.presenters.index.isLoading
        };
    });

    const {recommendProfessionalList} = useSelector(
        ({recommendList}: AppState) => recommendList
    );

    const {header} = useSelector((state: AppState) => ({
        header: state.header
    }));
    const direction =
    header.direction === "left" ? -1 : header.direction === "same" ? 0 : 1;

    const [msg, setMsg] = React.useState("");
    const [professionalName, setProfessionalName] = React.useState("");
    const [isInit, setIsinit] = React.useState<boolean>(true);

    const openMsg = (event: React.MouseEvent, flg: boolean, name: string) => {
        if (flg) {
            setMsg("del");
        } else {
            setMsg("add");
        }

        setProfessionalName(name);
    };

    const closeMsg = () => {
        setMsg("");
    };

    const {userFilter} = useSelector((state: AppState) => ({
        userFilter: state.userFilter.UserFilters
    }));

    useEffect(() => {
        dispatch(filterUserList(userFilter));

        for (const item of userFilter.skill) {
            if (!checkedSkills[item]) {
                setCheckedSkills({
                    ...checkedSkills,
                    [item]: true
                });
            }
        }

        for (const item of userFilter.tag) {
            if (!checkedTags[item]) {
                setCheckedTags({
                    ...checkedTags,
                    [item]: true
                });
            }
        }
    }, [dispatch, userFilter, checkedSkills, checkedTags]);

    // 何も選択されていない場合は、チェックを外す
    useEffect(() => {
        if (userFilter.skill.length === 0 && userFilter.tag.length === 0) {
            if (checkedSkills || checkedTags) {
                setCheckedSkills({});
                setCheckedTags({});
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userFilter]);

    useEffect(() => {
        if (recommendProfessionalList.length === 0 && isInit) {
            dispatch(GetRecommendProfessionalList());
            setIsinit(false);
        }
    }, [dispatch, recommendProfessionalList, isInit]);

    const changeSkillFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedSkills({
            ...checkedSkills,
            [event.target.name]: event.target.checked
        });

        if (!userFilter.skill.includes(event.target.name) && event.target.checked) {
            userFilter.skill.push(event.target.name);
        }

        if (userFilter.skill.includes(event.target.name) && !event.target.checked) {
            userFilter.skill = userFilter.skill.filter(
                (t) => t !== event.target.name
            );
        }

        dispatch(resetUserfilter(userFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    const changeTagFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCheckedTags({
            ...checkedTags,
            [event.target.name]: event.target.checked
        });

        if (!userFilter.tag.includes(event.target.name) && event.target.checked) {
            userFilter.tag.push(event.target.name);
        }

        if (userFilter.tag.includes(event.target.name) && !event.target.checked) {
            userFilter.tag = userFilter.tag.filter((t) => t !== event.target.name);
        }

        dispatch(resetUserfilter(userFilter));
        dispatch(changeMenu(header.from, header.to, "same"));
    };

    if (isLoading) {
        return (
            <div className={styles.noContent}>
                <CircularProgress size={60} style={{color: "var(--red)"}}/>
            </div>
        );
    }

    const style = users ? styles.index : styles.noContent;

    const contents = (
        <>
            <PresentersFilters
                anime={direction === 0 ? true : false}
                checkedSkills={checkedSkills}
                checkedTags={checkedTags}
                changeSkillFilter={changeSkillFilter}
                changeTagFilter={changeTagFilter}
            />

            <PresentersProfiles
                anime={direction === 0 ? true : false}
                users={users}
                msg={msg}
                professionalName={professionalName}
                recProList={recommendProfessionalList}
                openMsg={openMsg}
                closeMsg={closeMsg}
            />
        </>
    );

    return (
        <AnimatePresence>
            <motion.div
                key="professionalIndex"
                initial={{x: 300 * direction, opacity: 0.3}}
                animate={{x: 0, opacity: 1}}
                exit={{x: -300 * direction, opacity: 0}}
                className={style}
            >
                {contents}
            </motion.div>
        </AnimatePresence>
    );
}

export default PresentersIndex;
